import type { CreatureSkillEntryStorageInput, StoredCreatureSkillEntry } from '../types';

/**
 * Build the lean stored skill row after tier/mod/source discovery. Breakdown lines
 * must already be leaned by the legacy-boundary source resolver.
 */
export function storeCreatureSkillEntry(input: CreatureSkillEntryStorageInput): StoredCreatureSkillEntry | null {
    let assignedLevel = input.assignedLevel;
    const sources = [...input.sources];
    // Cancelling grants still own source lines for display and saved-grant deltas.
    const hasBreakdown = input.advDisLines.length > 0 || input.reversibleBreakdown;
    if (assignedLevel === 0) {
        if (input.itemType === 'defensive_skill' || input.itemType === 'innate_skill') {
            assignedLevel = 1;
            sources.push('default_defensive');
        } else {
            sources.push('default_flawed');
        }
    }

    if (
        assignedLevel === 0
        && sources.length === 1
        && sources[0] === 'default_flawed'
        && input.advDis === 0
        && !hasBreakdown
        && input.rawSp === null
        && input.forcedNaturalMainRoll === null
        && input.globalMod === 0
        && input.perSkillMod === 0
        && input.perSkillModLines.length === 0
    ) {
        return null;
    }

    const stored: StoredCreatureSkillEntry = { tier_level: assignedLevel, sources };
    if (input.advDis !== 0 || hasBreakdown) {
        if (input.advDis !== 0) stored.adv_dis_stacks = input.advDis;
        stored.adv_dis_breakdown = { lines: [...input.advDisLines] };
    }
    if (input.rawSp !== null) stored.raw_sp = input.rawSp;
    if (input.forcedNaturalMainRoll !== null) stored.forced_natural_main_roll = input.forcedNaturalMainRoll;
    if (input.globalMod !== 0) stored.skill_rolls_mod = input.globalMod;
    if (input.perSkillMod !== 0 || input.perSkillModLines.length > 0) {
        if (input.perSkillMod !== 0) stored.skill_roll_mod = input.perSkillMod;
        stored.skill_roll_mod_breakdown = { lines: [...input.perSkillModLines] };
    }
    return stored;
}
